<template>
    <div class="header-wrap">
        <header class="header">
            <div class="page-inner">
                <h1 class="logo" :class="{'is-show-mobile-navi': $store.state.is_show_mobile_navi}">
                    <svg viewBox="0 0 588 588">
                    <rect x="305.9" y="277.4" width="282.1" height="4.8"/>
                    <polygon points="463,32.1 463,250 588,250 588,254.8 458.2,254.8 458.2,27.3 588,27.3 588,32.1 "/>
                    <polygon points="449.3,263.7 588,263.7 588,268.5 305.9,268.5 305.9,263.7 444.6,263.7 444.6,18.4 305.9,18.4 305.9,13.7 588,13.7 588,18.4 449.3,18.4 "/>
                    <polygon points="435.6,27.3 435.6,254.8 305.9,254.8 305.9,250 430.9,250 430.9,32.1 305.9,32.1 305.9,27.3 "/>
                    <rect x="305.9" width="282.1" height="4.8"/>
                    <polygon points="18.4,0 18.4,0 18.4,0 "/>
                    <rect width="4.8" height="282.1"/>
                    <polygon points="268.5,0 268.5,282.1 263.7,282.1 263.7,11.7 143.7,281.5 143.4,282.1 138.7,282.1 138.5,281.5 18.4,11.7 18.4,282.1 13.7,282.1 13.7,0 18.4,0 18.4,0 141.1,275.7 263.7,0 263.7,0 "/>
                    <polygon points="27.3,53.6 27.3,282.1 32.1,282.1 32.1,76 123.8,282.1 129,282.1 32.1,64.3 "/>
                    <polygon points="254,0 143.7,247.9 141.1,253.7 138.5,247.9 28.2,0 33.4,0 141.1,242.1 248.8,0 "/>
                    <polygon points="263.7,0 263.7,0 263.7,0 "/>
                    <rect x="277.4" width="4.8" height="282.1"/>
                    <polygon points="254.8,53.6 254.8,282.1 250,282.1 250,76 158.3,282.1 153.1,282.1 250,64.3 "/>
                    <polygon points="18.4,305.9 18.4,305.9 18.4,305.9 "/>
                    <rect y="305.9" width="4.8" height="282.1"/>
                    <polygon points="268.5,305.9 268.5,588 263.7,588 263.7,317.6 143.7,587.4 143.4,588 138.7,588 138.5,587.4 18.4,317.6 18.4,588 13.7,588 13.7,305.9 18.4,305.9 18.4,305.9 141.1,581.5 263.7,305.9 263.7,305.9 "/>
                    <polygon points="27.3,359.5 27.3,588 32.1,588 32.1,381.9 123.8,588 129,588 32.1,370.2 "/>
                    <polygon points="254,305.9 143.7,553.8 141.1,559.6 138.5,553.8 28.2,305.9 33.4,305.9 141.1,547.9 248.8,305.9 "/>
                    <polygon points="263.7,305.9 263.7,305.9 263.7,305.9 "/>
                    <rect x="277.4" y="305.9" width="4.8" height="282.1"/>
                    <polygon points="254.8,359.5 254.8,588 250,588 250,381.9 158.3,588 153.1,588 250,370.2 "/>
                    <polygon points="429.6,305.9 305.9,588 311.1,588 434.8,305.9 "/>
                    <polygon points="464.3,305.9 588,588 582.8,588 459.1,305.9 "/>
                    <path d="M396.1,462.1L447,346.1l50.8,115.9H396.1z M503,462.1l-53.4-121.9l-2.6-5.9l-2.6,5.9l-53.4,121.9l-2.1,4.8H505L503,462.1z"/>
                    <path d="M375.2,475.7L447,312.1l71.7,163.6H375.2z M526,480.5l-2.1-4.8l-74.3-169.5l-0.1-0.3h-4.9l-0.1,0.3L370,475.7l-2.1,4.8 L320.8,588h5.2l47.1-107.5h147.6L567.9,588h5.2L526,480.5z"/>
                    <polygon points="558.2,588 553,588 511.8,494.2 382.1,494.2 340.9,588 335.7,588 376.9,494.2 379,489.4 514.9,489.4 517,494.2 "/>
                    </svg>
                    <video ref="video" autoplay muted webkit-playsinline playsinline @ended="ended">
                        <source :src="video_src" type="video/mp4">
                    </video>
                </h1>
                <nav v-if="!is_mobile" class="navi" :class="{'show-sub-menu': $store.state.show_sub_menu}">
                    <ul v-if="navi && navi.length !== 0">
                        <li v-for="(item, index) in navi" :key="item.ID" class="menu-item" :class="['menu-' + item.object_slug, {'current': show_index === index && $store.state.show_sub_menu}]" @click="$store.state.show_sub_menu = false">
                            <span @click="showSubMenu(item, index)"></span>
                            <Link :post_link="item.url" v-html="item.title" @mouseenter.native="showSubMenu(item, index)" @mouseleave.native="showSubMenu(false)"></Link>
                        </li>
                    </ul>
                    <span @click="openCart" v-if="$route.name === 'shop-page' || $route.name === 'shop-category' || $route.name === 'single-product'" class="cart-ico">☑</span>
                    <span @click="openSearch" v-if="!$store.state.show_sub_menu" class="i-search">⌕</span>
                    <span v-if="$store.state.show_sub_menu" class="close" @click="$store.state.show_sub_menu = false">⒳</span>
                </nav>
            </div>
        </header>

        <nav class="sub-navi" v-if="!is_mobile && $store.state.show_sub_menu">
            <div class="page-inner">
                <div class="menus" v-if="navi && navi.length !== 0">
                    <ul v-for="(item, index) in navi" :key="item.ID" v-if="show_index === index || item.object_slug === 'home-page'" class="menus-item" :class="['menus-' + item.object_slug]">
                        <li v-if="item.object_slug === 'home-page'">
                            <input type="text" placeholder="Search" ref="search_input" v-on:keyup.enter="openSearch(true)" />
                            <i @click="openSearch(true)">⌕</i>
                        </li>
                        
                        <li v-for="sub_item in item.children" :key="sub_item.id" class="menu-item" :class="['menu-' + sub_item.object_slug]">
                            <Link :key="sub_item.id" :post_link="sub_item.url" v-html="sub_item.title"></Link>
                        </li>
                    </ul>
                </div>
                <div class="logo">
                    <svg viewBox="0 0 588 588">
                    <rect x="305.9" y="277.4" width="282.1" height="4.8"/>
                    <polygon points="463,32.1 463,250 588,250 588,254.8 458.2,254.8 458.2,27.3 588,27.3 588,32.1 "/>
                    <polygon points="449.3,263.7 588,263.7 588,268.5 305.9,268.5 305.9,263.7 444.6,263.7 444.6,18.4 305.9,18.4 305.9,13.7 588,13.7 588,18.4 449.3,18.4 "/>
                    <polygon points="435.6,27.3 435.6,254.8 305.9,254.8 305.9,250 430.9,250 430.9,32.1 305.9,32.1 305.9,27.3 "/>
                    <rect x="305.9" width="282.1" height="4.8"/>
                    <polygon points="18.4,0 18.4,0 18.4,0 "/>
                    <rect width="4.8" height="282.1"/>
                    <polygon points="268.5,0 268.5,282.1 263.7,282.1 263.7,11.7 143.7,281.5 143.4,282.1 138.7,282.1 138.5,281.5 18.4,11.7 18.4,282.1 13.7,282.1 13.7,0 18.4,0 18.4,0 141.1,275.7 263.7,0 263.7,0 "/>
                    <polygon points="27.3,53.6 27.3,282.1 32.1,282.1 32.1,76 123.8,282.1 129,282.1 32.1,64.3 "/>
                    <polygon points="254,0 143.7,247.9 141.1,253.7 138.5,247.9 28.2,0 33.4,0 141.1,242.1 248.8,0 "/>
                    <polygon points="263.7,0 263.7,0 263.7,0 "/>
                    <rect x="277.4" width="4.8" height="282.1"/>
                    <polygon points="254.8,53.6 254.8,282.1 250,282.1 250,76 158.3,282.1 153.1,282.1 250,64.3 "/>
                    <polygon points="18.4,305.9 18.4,305.9 18.4,305.9 "/>
                    <rect y="305.9" width="4.8" height="282.1"/>
                    <polygon points="268.5,305.9 268.5,588 263.7,588 263.7,317.6 143.7,587.4 143.4,588 138.7,588 138.5,587.4 18.4,317.6 18.4,588 13.7,588 13.7,305.9 18.4,305.9 18.4,305.9 141.1,581.5 263.7,305.9 263.7,305.9 "/>
                    <polygon points="27.3,359.5 27.3,588 32.1,588 32.1,381.9 123.8,588 129,588 32.1,370.2 "/>
                    <polygon points="254,305.9 143.7,553.8 141.1,559.6 138.5,553.8 28.2,305.9 33.4,305.9 141.1,547.9 248.8,305.9 "/>
                    <polygon points="263.7,305.9 263.7,305.9 263.7,305.9 "/>
                    <rect x="277.4" y="305.9" width="4.8" height="282.1"/>
                    <polygon points="254.8,359.5 254.8,588 250,588 250,381.9 158.3,588 153.1,588 250,370.2 "/>
                    <polygon points="429.6,305.9 305.9,588 311.1,588 434.8,305.9 "/>
                    <polygon points="464.3,305.9 588,588 582.8,588 459.1,305.9 "/>
                    <path d="M396.1,462.1L447,346.1l50.8,115.9H396.1z M503,462.1l-53.4-121.9l-2.6-5.9l-2.6,5.9l-53.4,121.9l-2.1,4.8H505L503,462.1z"/>
                    <path d="M375.2,475.7L447,312.1l71.7,163.6H375.2z M526,480.5l-2.1-4.8l-74.3-169.5l-0.1-0.3h-4.9l-0.1,0.3L370,475.7l-2.1,4.8 L320.8,588h5.2l47.1-107.5h147.6L567.9,588h5.2L526,480.5z"/>
                    <polygon points="558.2,588 553,588 511.8,494.2 382.1,494.2 340.9,588 335.7,588 376.9,494.2 379,489.4 514.9,489.4 517,494.2 "/>
                    </svg>
                </div>

            </div>
        </nav>

        <span v-if="is_mobile" class="open-mobile-navi" @click="$store.state.is_show_mobile_navi = !$store.state.is_show_mobile_navi" :class="{'is-show-mobile-navi': $store.state.is_show_mobile_navi}">
            <i v-if="$store.state.is_show_mobile_navi">⒳</i>
            <i v-else>☰</i>
        </span>

        <nav class="mobile-navi" v-if="$store.state.is_show_mobile_navi && is_mobile">
            <ul v-if="navi && navi.length !== 0">
                <li v-for="item in navi" :key="item.ID">
                    <div class="menu-item">
                        <Link :post_link="item.url" v-html="item.title"></Link>
                        <span v-if="item.children && item.object_slug !== 'home-page'" @click="openMobileSubMenu(item)">
                            <i :class="{'is-open': item.show_sub_menu}">⒳</i>
                        </span>
                    </div>

                    <ul :class="{'sub-menu': item.object_slug !== 'home-page'}" v-if="(item.children && item.show_sub_menu) || item.object_slug === 'home-page'">
                        <li v-for="sub_item in item.children" :key="sub_item.ID">
                            <Link :post_link="sub_item.url" v-html="sub_item.title"></Link>
                        </li>
                        <li v-if="item.object_slug === 'home-page'" @click="openSearch(false)">
                            Search
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <div class="mobile-navi-bg" v-if="$store.state.is_show_mobile_navi && is_mobile"></div>
        <span @click="openCart" v-if="is_mobile && $route.name === 'shop-page' || $route.name === 'shop-category' || $route.name === 'single-product'" class="mobile-cart-ico">☑</span>


    </div>


</template>

<script>


import Link from '@/components/ui/Link.vue';
import { EventBus } from '@/events/bus.js';

export default {
    name: 'site-header',

    data () {
        return {
            navi: [],
            show_index: 1,
            timer: null,
            is_mobile: false,
            video_src: ''
        }
    },

    components: {
        Link,
    },

    methods: {
        openCart() {
            EventBus.$emit('cart.open');
            // if (window.innerWidth < 787) {
            //     window.location.href = window.globals.home_url + '/cart/';
            // } else {
            //     EventBus.$emit('cart.open');
            // }
        },

        openSearch(is_keyword = false) {
            let keyword = false;
            if (is_keyword === true && this.$refs.search_input && this.$refs.search_input[0].value) {
                keyword = this.$refs.search_input[0].value;
            } else if (is_keyword === true) {
                return false;
            }

            EventBus.$emit('search.open', {
                keyword: keyword,
            });
        },
        
        showSubMenu(item, index) {
            if (item === false) {
                if (this.timer !== null) clearTimeout(this.timer);
            } else {
                if (item.object_slug !== 'home-page') {
                    if (this.timer !== null) clearTimeout(this.timer);
                    this.timer = setTimeout( () => {
                        this.$store.state.show_sub_menu = true; 
                        this.show_index = index;
                    }, 150);
                }
            }
        },

        openMobileSubMenu(item) {
            if (!item.show_sub_menu) {
                this.navi.forEach(el => {
                    el.show_sub_menu = false;
                });
                item.show_sub_menu = true;
            } else {
                item.show_sub_menu = false;

            }

        },

        ended() {
            document.documentElement.classList.add('end');
        }
    },

    mounted () {
        this.is_mobile = window.innerWidth < 768;
        this.video_src = window.globals.template_url + '/logo.mp4';

        this.$ajax.get('/menus/30').then(res => {
            res.data.items.forEach(menu => {
                menu.show_sub_menu = false;
            });
            
            this.navi = res.data.items;
        });

        this.$ajax.get('/options').then(res => {
            // console.log(res.data)
            this.$store.state.footer = res.data.footer;
            this.$store.state.social = res.data.social;
            this.$store.state.cookies = res.data.cookies;;
            this.$store.state.global = res.data.global;
            this.$store.state.collection = res.data.collection;
            this.$store.state.highlights = res.data.highlights;

        });
    },

}
</script>

<style lang="scss">
    body.is-init .header .logo {
        display: block;
    }

    .header {
        min-height: 6.5rem;
        
        .page-inner {
            position: relative;
        }

        video {
            position: absolute;
            right: 0;
            top: 0;
            z-index: 9;
            width: 113%;
            transform: translate(5.7%, -5.7%);
            pointer-events: none;
            opacity: 1;
            transition: opacity .3s;

            @at-root {
                html.end & {
                    opacity: 0;
                }
            }
        }

        .logo {
            width: 55rem;
            position: absolute;
            right: var(--padding);
            top: var(--padding);
            z-index: -1;
            display: none;
            overflow: hidden;
            height: 100vh;

            svg {
                display: block;
                width: 100%;
                position: absolute;
                left: 0;
                top: 0;
                fill: var(--sand);
                opacity: 0;
                transition: opacity .3s;

                @at-root {
                    html.end & {
                        opacity: 1;
                    }
                }

            }
        }
    }

    .navi {
        padding: calc(var(--padding) - .2rem) var(--padding) var(--padding);
        position: fixed;
        top: 0;
        z-index: 9999;
        box-sizing: border-box;
        width: 100%;
        // max-width: var(--page-width);
        transform: translate(0%, 0%);
        transition: transform .2s ease;
        font-size: var(--large-size);
        opacity: 0;
        transition: opacity .3s;

        @at-root {
            html.end & {
                opacity: 1;
            }
        }

        &.show-sub-menu {
            transform: translate(0%, 0%)  !important;
            background: transparent !important;

            ul li > span {
                display: none;
            }
        }
        
        ul {
            display: flex;
        }

        li {
            padding-right: var(--padding);
            line-height: 1;
            position: relative;

            & > span {
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 100%;
                cursor: pointer;
            }

            & > a:hover {
                text-decoration-thickness: .18rem;
            }


            &.menu-home-page {
                display: none;
            }

            & > a:hover,
            & > span:hover + a,
            &.current a {
                text-decoration-thickness: .18rem;
                text-decoration: underline;
            }
        }

        .current + .menu-home-page,
        .current + li + .menu-home-page,
        .current + li +  li + .menu-home-page {
            display: block;
        }


        .cart-ico,
        .i-search,
        .close {
            position: fixed;
            top: calc(var(--padding-50) + .18rem);
            right: 7.5rem;
            cursor: pointer;
            font-size: calc(var(--large-size) + 1.5rem);
        }

        .cart-ico {

            & + span.close,
            & + .i-search {
                right: 12rem;
            }

        }
    }

    @media only screen and (min-width: 767px) {
        .wrap {
            position: fixed;
            left: 0;
            top: 0;
            z-index: 99;
            overflow: hidden;
            height: 100%;
            width: 100%;
        }

        body.woocommerce-page .navi,
        body.woocommerce-page .header-wrap + div {
            opacity: 1;
        }


        .header-wrap + div {
            opacity: 0;
            transition: opacity .3s;

            @at-root {
                html.end .wrap {
                    position: static;
                    overflow: visible;
                    height: auto;
                }
                html.end & {
                    opacity: 1;
                }
            }
        }
    }
    
    .sub-navi {
        position: fixed;
        top: 0;
        z-index: 9998;
        left: 0;
        height: 100%;
        width: 100%;
        background: var(--yellow);

        .menus {
            padding: 9rem var(--padding-50) var(--padding-50);
            display: flex;
            font-size: var(--title-size);
            line-height: 1.18;

            ul {
                width: 50%;
                box-sizing: border-box;
                padding: 0 var(--padding-50);
                line-height: 1.15;
                
                &.menus-home-page {
                    li:nth-child(2) {
                        margin-top: -.7rem;
                    }
                }

                a:hover {
                    text-decoration-thickness: .25rem;
                }
            }

            input {
                border: none;
                background: transparent;
                font-size: var(--title-size);
                padding: 0;
                border-bottom: solid .25rem;
                max-width: 25rem;
                margin-right: 3rem;
                height: 4.25rem;
                margin-bottom: .5rem;

                &::placeholder {
                    color: var(--font-color);
                }

                & + i {
                    line-height: 1;
                    position: relative;
                    top: .5rem;
                    cursor: pointer;
                    right: 3rem;
                }
            }


        }

        .page-inner {
            position: relative;
        }

        .logo {
            width: 50rem;
            position: absolute;
            right: var(--padding);
            top: var(--padding);
            z-index: -1;

            svg {
                display: block;
                width: 100%;
                position: absolute;
                left: 0;
                top: 0;
                fill: var(--sand);
            }
        }
    }

    body.page-home {
        .header {
            min-height: unset;
        }
    }

    body.is-sticky .navi {
        transform: translate(0%, -100%);
        background: white;
    }

    body.is-sticky.show-header .navi {
        transform: translate(0%, 0%);
    }

    .open-mobile-navi {
        position: fixed;
        right: var(--padding-50);
        top: var(--padding-50);
        height: 12rem;
        width: 12rem;
        line-height: 12rem;
        font-size: 8rem;
        color: white;
        text-align: center;
        border-radius: 50%;
        background: var(--blue);
        z-index: 9000;

        &.is-show-mobile-navi {
            top: auto;
            bottom: var(--padding);
        }
    }

    .mobile-navi-bg {
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999990;
        background: var(--yellow);
        position: fixed;
    }

    .mobile-navi {
        padding: var(--padding);
        width: 100%;
        height: 100%;
        overflow: auto;
        box-sizing: border-box;
        left: 0;
        top: 0;
        z-index: 999998;
        position: fixed;
        line-height: 1.4;
        
        & > ul {

            & > li {
                font-size: var(--title-size);
                position: relative;
                
                & > .menu-item {
                    display: flex;
                    
                    span {
                        flex: 1;
                        text-align: right;    
                    }

                    i {
                        position: absolute;
                        font-size: var(--large-size);
                        right: 0;
                        top: 1.2rem;
                        transform: rotate(45deg);

                        &.is-open {
                            transform: rotate(0deg);
                        }
                    }
                }
            }

            .sub-menu {
                padding: 0 0 var(--padding);
            }
        }
    }

    .mobile-cart-ico {
        position: fixed;
        bottom: 16rem;
        right: var(--padding-50);
        cursor: pointer;
        font-size: calc(var(--large-size) + 1.5rem);
        height: 46px;
        width: 46px;
        line-height: 46px;
        text-align: center;
        border-radius: 50%;
        background: var(--orange);
        z-index: 99;
        display: none;
    }

    @media only screen and (max-width: 767px) {
        .navi {
            display: none;
        }

        body.home .header .logo,
        body.home.is-init .header .logo {
            display: block;
        }

        .mobile-cart-ico,
        body.is-init .header .logo {
            display: block;
        }
        .header {
            min-height: unset;

            video {
                display: none;
            }
            
            .logo {
                width: 90vw;
                right: 5vw;
                top: 5vw;
                display: block;

                &.is-show-mobile-navi {
                    position: fixed;
                    z-index: 999995;
                }


                svg {
                    display: block;
                    width: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    fill: var(--sand);
                    opacity: 1 !important;
                }


                @at-root {
                    body.page-home & {
                        width: 90vw;

                        svg {
                            fill: var(--sand);
                        }
                    }
                }
            }
        }

    }
    

    // body.page-single-festival {
    //     .navi {
    //         background: transparent;
    //     }
    // }

</style>
